import React, { useState, useContext, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { withTranslation } from 'react-i18next'
import { Button, Fab } from '@material-ui/core'
import { tableIcons } from '../../Utils/TableIcons'
import { PageContext } from '../../Context/PageProvider'
import AddIcon from '@material-ui/icons/Add'
import PermissionsModal from '../../Components/Modals/PermissionsModal'
import RoleModal from '../../Components/Modals/RoleModal'
import DataTable from '../../Utils/DataTable'

function AccessManagement({ t }) {
    const classes = useStyles()
    const context = useContext(PageContext)
    const api = context.api
    const tableColumns = [
        { title: 'Name', field: 'title' },
        { title: 'Description', field: 'description' },
        { title: '', field: 'operations', editable: 'never', render: role => (<Button color="primary" size="small" onClick={() => setEditRolePermissions(role)}>{t('edit_permissions')}</Button>) },
    ]
    const [roles, setRoles] = useState(null)
    const [editRolePermissions, setEditRolePermissions] = useState(null)
    const [newRole, setNewRole] = useState(false)
    const [editRole, setEditRole] = useState(null)


    const getRoles = async () => {
        try {
            const roleList = await api.adminService.getRoles()
            setRoles(roleList)
        } catch (error) {
            console.log("can't get roles: ", error)
        }
    }

    useEffect(() => {
        getRoles()
    }, [])

    if (!roles) return (null)
    return (
        <div className={classes.root}>
            <DataTable
                columns={tableColumns}
                data={roles}
                actions={[
                    {
                        icon: tableIcons.Edit,
                        tooltip: t('edit'),
                        onClick: (event, data) => setEditRole(data)
                    }
                ]}
                editable={{
                    isEditable: rowData => !rowData.isAdmin && !rowData.isAuthenticated,
                    isDeletable: rowData => !rowData.isAdmin && !rowData.isAuthenticated,
                    onRowDelete: (async (role) => {
                        try {
                            await api.adminService.deleteRole(role._id)
                            setRoles(prevState => {
                                const data = [...prevState]
                                data.splice(data.indexOf(role), 1)
                                return data
                            })

                        } catch (error) {
                            console.log(error)
                        }

                    })
                }}
            />
            <Fab
                aria-label="add"
                color="primary"
                className={classes.addButton}
                onClick={() => setNewRole(true)}>
                <AddIcon />
            </Fab>

            {
                editRolePermissions &&
                <PermissionsModal
                    title={editRolePermissions.title}
                    open={true}
                    onClose={async () => {
                        setEditRolePermissions(null)
                        await getRoles()
                    }}
                    role={editRolePermissions} />
            }
            {
                newRole &&
                <RoleModal
                    open={true}
                    onClose={async () => {
                        setNewRole(false)
                        await getRoles()
                    }}
                />
            }
            {
                editRole &&
                <RoleModal
                    open={true}
                    onClose={async () => {
                        setEditRole(null)
                        await getRoles()
                    }}
                    role={editRole}
                />
            }
        </div >
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        width: '100%'
    },
    addButton: {
        position: 'absolute',
        bottom: '50px',
        right: '50px',
        zIndex: '99999',
        '& svg': {
            color: theme.palette.common.white
        }
    },
    mtAddIcon: {
        display: 'none'
    }
}))

export default withTranslation()(AccessManagement)